var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212.348,
    height: 136.168,
    viewBox: "0 0 212.348 136.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-227 -187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.546,187H233.182a7,7,0,0,0-6.992,6.992v21.346a7,7,0,0,0,6.992,6.992H431.546a7,7,0,0,0,6.992-6.992V193.992A7,7,0,0,0,431.546,187Zm6.256,28.338a6.265,6.265,0,0,1-6.256,6.256H233.182a6.265,6.265,0,0,1-6.256-6.256V193.992a6.265,6.265,0,0,1,6.256-6.256H431.546a6.265,6.265,0,0,1,6.256,6.256Z",
    transform: "translate(0.81)",
    fill: "#98a6b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.546,342.6H233.182a7,7,0,0,1-6.992-6.992V314.266a7,7,0,0,1,6.992-6.992H431.546a7,7,0,0,1,6.992,6.992v21.345A7,7,0,0,1,431.546,342.6ZM233.182,308.01a6.263,6.263,0,0,0-6.256,6.256v21.345a6.263,6.263,0,0,0,6.256,6.257H431.546a6.263,6.263,0,0,0,6.257-6.256V314.266a6.263,6.263,0,0,0-6.256-6.256Z",
    transform: "translate(0.81 -69.855)",
    fill: "#e7eaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.546,462.878H233.182a7,7,0,0,1-6.992-6.992V434.54a7,7,0,0,1,6.992-6.992H431.546a7,7,0,0,1,6.992,6.992v21.345A7,7,0,0,1,431.546,462.878Zm-198.364-34.6a6.263,6.263,0,0,0-6.256,6.256v21.345a6.263,6.263,0,0,0,6.256,6.257H431.546a6.263,6.263,0,0,0,6.257-6.256V434.54a6.263,6.263,0,0,0-6.257-6.258Z",
    transform: "translate(0.81 -139.71)",
    fill: "#e7eaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.947,224.449a12.17,12.17,0,1,1,12.17-12.17A12.17,12.17,0,0,1,289.947,224.449Z",
    transform: "translate(-29.152 -7.613)",
    fill: "#008d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.131,244.685H359.221a2.944,2.944,0,0,1,0-5.889H489.131a2.944,2.944,0,0,1,0,5.889Z",
    transform: "translate(-74.744 -30.083)",
    fill: "#e7eaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.8,214.836H359.214a2.944,2.944,0,0,1,0-5.889H446.8a2.944,2.944,0,1,1,0,5.889Z",
    transform: "translate(-74.74 -12.747)",
    fill: "#e7eaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.947,344.721a12.17,12.17,0,1,1,12.17-12.17A12.17,12.17,0,0,1,289.947,344.721Z",
    transform: "translate(-29.152 -77.467)",
    fill: "#e7eaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.131,364.958H359.221a2.944,2.944,0,0,1,0-5.889H489.131a2.944,2.944,0,0,1,0,5.888Z",
    transform: "translate(-74.744 -99.938)",
    fill: "#e7eaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.8,335.11H359.214a2.944,2.944,0,0,1,0-5.889H446.8a2.944,2.944,0,1,1,0,5.889Z",
    transform: "translate(-74.74 -82.602)",
    fill: "#e7eaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.947,465a12.17,12.17,0,1,1,12.17-12.17A12.17,12.17,0,0,1,289.947,465Z",
    transform: "translate(-29.152 -147.322)",
    fill: "#e7eaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.131,485.233H359.221a2.944,2.944,0,0,1,0-5.889H489.131a2.944,2.944,0,0,1,0,5.888Z",
    transform: "translate(-74.744 -169.793)",
    fill: "#e7eaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.8,455.383H359.214a2.944,2.944,0,0,1,0-5.889H446.8a2.944,2.944,0,1,1,0,5.889Z",
    transform: "translate(-74.74 -152.457)",
    fill: "#e7eaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.013,225.209a1.392,1.392,0,0,1-.838-.278l-.015-.011-3.155-2.413a1.4,1.4,0,0,1,1.706-2.225l2.043,1.567,4.828-6.3a1.4,1.4,0,0,1,1.964-.259h0l-.03.042.031-.042a1.4,1.4,0,0,1,.259,1.965l-5.679,7.406a1.4,1.4,0,0,1-1.115.545Z",
    transform: "translate(-38.839 -16.263)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelection);
export default __webpack_public_path__ + "static/media/selection.8658559a0dd695aced8a4ff2465ee4b7.svg";
export { ForwardRef as ReactComponent };